import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const Container = styled(FlexContainer)`
  display: flex;
  width: 375px;
  padding: ${({ theme: { system } }) => `0px ${system.fds_sys_spacing_S}`};
  @media (max-width: ${({ theme: { reference } }) => reference.breakpoints.MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Link = styled.a`
  color: ${({ theme: { colors } }) => colors.green_500};
  text-decoration: none;
`;

export const ButtonContainer = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  height: 70px;

  @media (max-width: ${({ theme: { reference } }) => reference.breakpoints.MOBILE_WIDTH}) {
    border-top: 1px solid ${({ theme }) => theme.system.border.fds_sys_color_border_primary};
  }
`;
